import { Services } from '@sigma-frontend-libs/commons'
import { TaskStates } from '@sigmasms/shared-types'

import { tasksStates } from '@/components/services/tasks/utils'
import sticker from '@/components/sticker'

export default function(h) {
  const state = this.value.state

  let iconTooltip
  if (state === TaskStates.scheduled) {
    iconTooltip = this.stateLabel
  } else {
    iconTooltip = this.getTranslate(`${Services.tasks}.states.${state}`)
  }

  return h(
    sticker,
    {
      props: {
        value: this.$_value,
        label: this.getTranslate(`${Services.tasks}.labels.state`),
        icon: tasksStates[state].icon,
        color: tasksStates[state].color,
        tooltip: this.stateTooltip,
        iconTooltip
      }
    }
  )
}
